module.exports = __webpack_public_path__ + "img/c08_unitelephantarcher_Normal_ua.8e864bad.webp";